import { EscalaPeriodoColaborador } from "./escala";
import { ItemColaborador } from "./itens_colaboradores";
import { Setor } from "./setor";
import { Turno } from "./turno";

export interface Solicitacoes {
  pendentes: SolicitacaoTroca[],
  concretizadas: SolicitacaoTroca[];
}

export interface SolicitacaoTroca {
  id: string;
  tipoSolicitacao: TipoSolicitacao;
  criadoEm: string;
  itemOrigem: ItemColaborador | null;// No origem são as que eu enviei

  itensDestinoTroca: ItemColaboradorTroca[];// No destino são as que recebi
  colaboradoresDestinoPasse: EscalaPeriodoColaboradorPasse[];
  destinoRemanejamento: DestinoRemanejamento | null;

  status: StatusSolicitacao;
  atualizadoEm?: string;
}

export enum TipoSolicitacao {
  TROCA = 'TROCA',
  PASSAGEM = 'PASSAGEM',
  REMANEJAMENTO = 'REMANEJAMENTO'
}

export enum StatusSolicitacaoItem {
  PENDENTE_COLABORADOR = 'PENDENTE_COLABORADOR',
  PENDENTE_GESTOR = 'PENDENTE_GESTOR',
  APROVADA = 'APROVADA',
  REJEITADA_COLABORADOR = 'REJEITADA_COLABORADOR',
  REJEITADA_GESTOR = 'REJEITADA_GESTOR',
  CANCELADA = 'CANCELADA'
}

export enum StatusSolicitacao {
  PENDENTE = 'PENDENTE',
  APROVADA = 'APROVADA',
  REJEITADA = 'REJEITADA',
  CANCELADA = 'CANCELADA'
}

export interface ItemColaboradorTroca {
  itemColaborador: ItemColaborador;
  status: StatusSolicitacaoItem;
  motivo?: string;
  atualizadoEm?: string;
}

export interface DestinoRemanejamento {
  setor: Setor;
  turno: Turno;
  data: string;
}

export interface EscalaPeriodoColaboradorPasse {
  escalaPeriodoColaborador: EscalaPeriodoColaborador;
  status: StatusSolicitacaoItem;
  motivo?: string;
  atualizadoEm?: string;
}
